import React, { Component } from 'react';

export default class Sanitaer extends Component {
  
  componentDidMount() {
      try {
        window.adjustSubmenu();
      }
      catch(err) {
        console.log(err);
      }
  }
  
  render() {
    return (
      <div className="Sanitaer">
        <div id="content" className="container" role="main">
          <div id="Unser Service" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML">
                <a name="unser-service"></a>
                <div className="section">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">UNSER SERVICE</h1>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-wrench fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">Kundendienst und Wartungsservice</h4>
                        <p className="text-muted">Auch im Bereich Sanitär bieten wir Ihnen einen umfassenden Kundendienst und Wartungsservice
                                    an. Ob Rohrreinigung, Boilerentkalkung oder Wartung Ihrer Wasser- Enthärtungsanlage,
                                    sprechen Sie uns an, wir beraten Sie gerne. </p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-pencil fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">Individuelle Planung und Beratung</h4>
                        <p className="text-muted">Sie Planen einen Neubau oder möchten Ihre Wasser- und Abwasserleitungen erneuern? Wir beraten
                                    Sie gerne und finden für Ihr Zuhause das passenden Abwasser- und Trinkwassersystem. Auch
                                    über Regenwassernutzungsanlagen, Regenrückstausicherungen und Abwasserhebeanlagen informieren
                                    wir Sie gerne.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-home fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">Abwicklung von Großprojekten</h4>
                        <p className="text-muted">Sie suchen einen Ansprechpartner zur Planung und Abwicklung Ihres Mehrfamilienhauses? Sie
                                    planen eine Sanierung oder einen Neubau im öffentlichen oder gewerblichen Bereich? Sprechen
                                    Sie uns an, wir beraten Sie gerne.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/sanitaer/Sanitaer.js